<template>

  <div>
    <fin-fill-portfolio-content
      :archetype="onboardingArchetype"
      :asset-type="assetType"
      :strategy="strategy"
      :value="value"
      @cancel="$emit('cancel')"
      @input="(val) => $emit('input', val)"
    />
  </div>

</template>

<script>
import FinFillPortfolioContent from "@/components/pages/onboarding/Step4/FillPortfolio/indexContent"
import {mapGetters} from "vuex"

export default {
  name: "FinFillPortfolio",
  components: {FinFillPortfolioContent},
  props: {
    value: {
      type: Array
    },
    assetType: {
      type: Object
    }
  },
  computed: {
    ...mapGetters('auth', ['onboardingArchetypeID']),
    ...mapGetters('archetype', ['archetypeFinder']),

    onboardingArchetype() {
      return this.archetypeFinder?.byArchetypeId(this.onboardingArchetypeID)
    },
    strategy() {
      let mapping = undefined
      if (this.onboardingArchetype) {
        mapping = this.onboardingArchetype.etfStrategyModels.items.map((item) => {
          return {
            assetClassId: item.etfStrategyModel.assetClass,
            strategyName: item.etfStrategyModel.name,
            strategyId: item.strategyModelId
          }
        })
        mapping.push({
          assetClassId: 'SHARE',
          strategyName: this.onboardingArchetype.mainStrategyShare.name,
          strategyId: this.onboardingArchetype.mainStrategyShare.id
        })
      }
      const result = mapping ? mapping.find(item => item.assetClassId === this.assetType.id) : undefined
      return {
        name: result?.strategyName,
        id: result?.strategyId
      }
    }
  }
}
</script>

<style scoped>

</style>
